import { render, staticRenderFns } from "./BrandSafety.vue?vue&type=template&id=ac1f7490&scoped=true"
import script from "./BrandSafety.vue?vue&type=script&lang=js"
export * from "./BrandSafety.vue?vue&type=script&lang=js"
import style0 from "./BrandSafety.vue?vue&type=style&index=0&id=ac1f7490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1f7490",
  null
  
)

export default component.exports